import React, { createContext, useContext } from "react";
import { message } from "antd";

// Create Message Context
const MessageContext = createContext(null);

/**
 * MessageProvider Component
 * Provides Ant Design message API globally to all child components
 * 
 * @param {React.ReactNode} children - Child components
 */
export const MessageProvider = ({ children }) => {
  const [messageApi, contextHolder] = message.useMessage();

  return (
    <MessageContext.Provider value={messageApi}>
      {contextHolder}
      {children}
    </MessageContext.Provider>
  );
};

/**
 * Custom hook to access message API from context
 * @returns {Object} messageApi instance
 */
export const useMessageApi = () => {
  const context = useContext(MessageContext);
  if (!context) {
    throw new Error("useMessageApi must be used within MessageProvider");
  }
  return context;
};
